import { apiInvoke, shouldLoad } from '@/store/helpers/load';
import type { LoadMemberStatusResponse } from './types';
import { Paths } from '../constants';
import type { APILoadParams } from '@/store/helpers/types';
import type { MemberStatusStore } from '@/store/memberstatus';

export async function loadMemberStatus(
  { state, dispatch }: MemberStatusStore,
  { force, api, auth }: APILoadParams,
) {
  if (!shouldLoad(state.loaded, force, auth)) {
    return;
  }

  const res = await apiInvoke<LoadMemberStatusResponse>(
    api,
    Paths.memberStatus,
    auth,
  );
  dispatch({ type: 'setMemberStatus', data: res.memberStatus || [] });
}
